import {field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class EmailSettingData extends LocalisableEntityData<EmailSettingData> {
    @identifier emailSettingId: number;
    @field name: string;
    @field emailAddress: string;
    @field emailUsername: string;
    @field emailPassword: string;
    @field emailHost: string;
    @field smtpPort: number;
    @field useTLS: boolean;
    @field smtpAuth: boolean;
    @field useSystemSettings: boolean;

    systemEmailAddress: string;
}

export class EmailSettingReferenceData extends LocalisableEntityData<EmailSettingReferenceData> {
    @identifier emailSettingId: number;
    @field name: string;
}
